export default [
  {
    path: '/dashboard/sifnf',
    name: 'dashboard-sifnf',
    component: () => import('@/views/dashboard/sifnf/SifnfDashboard.vue'),
    meta: {
      pageTitle: 'Своя Игра',
      breadcrumb: [{ text: 'Дэшборд', active: true }],
      resource: 'dashboard',
      action: 'view',
    },
  },
  {
    path: '/competitors',
    name: 'competitors-list',
    component: () => import('@/views/competitors/CompetitorsList.vue'),
    meta: {
      pageTitle: 'Конкуренты',
      breadcrumb: [{ text: 'Дэшборд', active: true }],
      resource: 'competitors',
      action: 'view',
    },
  },
  {
    path: '/competitors/:id',
    name: 'competitors-detail',
    component: () => import('@/views/competitors/CompetitorDetail.vue'),
    meta: {
      pageTitle: 'Конкуренты',
      breadcrumb: [
        { text: 'Дэшборд', active: true },
        { text: 'Конкуренты', to: { name: 'competitors-list' } },
      ],
      resource: 'competitors',
      action: 'view',
      navActiveLink: 'competitors-list',
    },
  },
  {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Analytics.vue'),
  },
  {
    path: '/dashboard/ecommerce',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
  },
]
